import * as React from 'react';
import { Switch } from '@repo/ui-web';
import { switchStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

type SwitchState = (typeof switchStates)[number];

export function SwitchShowcase() {
  const [state, setState] = React.useState<SwitchState>('off');
  const checked = state === 'on';
  const disabled = state === 'disabled';

  return (
    <div className="space-y-4">
      <StateToggle options={switchStates} value={state} onChange={setState} label="State" />
      <div className="flex items-center gap-2">
        <Switch checked={checked} onCheckedChange={() => null} disabled={disabled} />
        <span className="text-sm font-medium text-foreground">Enable alerts</span>
      </div>
    </div>
  );
}
